import { platformBridgeChecker } from '@zoom/hybrid-jsbridge';

class Platform {
  static isCEF() {
    return platformBridgeChecker.isCEF(window);
  }

  static isWebView2() {
    return platformBridgeChecker.isWebView2(window);
  }

  static isIOS() {
    return platformBridgeChecker.isIOS(window);
  }

  static isMacOS() {
    return platformBridgeChecker.isMacOS(window);
  }

  static isWindows() {
    return Platform.isWebView2();
  }
  static isLinux() {
    return platformBridgeChecker.isLinux(window);
  }

  static isAndroid() {
    return platformBridgeChecker.isAndroid(window);
  }
}

export { Platform };
